import { QueryClient } from "@tanstack/react-query";

/**
 * Builds the React Query client for admin-v2.
 *
 * Retries are disabled so a failed request surfaces immediately to the caller's
 * error handling (the app renders user-friendly error states) instead of being
 * masked by silent retries; this matches the convention in the other frontends.
 * A fresh instance is created per app, and per test render, so a cache is never
 * shared across unrelated trees.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  });
}
